export const MedicalAppointment = {
    path: '/medical_appointments',
    name: 'medical_appointments',
    component: () => import('@/views/Medical/Appointment/MedicalAppointmentPage.vue'),
    children: [
        {
            path: '/medical_appointments/add',
            name: 'medical_appointments.add',
            component: () => import('@/views/Medical/Appointment/Form/MedicalAppointmentForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/medical_appointments/edit/:id',
            name: 'medical_appointments.edit',
            component: () => import('@/views/Medical/Appointment/Form/MedicalAppointmentForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/medical_appointments/delete/:id',
            name: 'medical_appointments.delete',
            component: () => import('@/views/Medical/Appointment/Form/MedicalAppointmentForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/medical_appointments/view/:id',
            name: 'medical_appointments.view',
            component: () => import('@/views/Medical/Appointment/Form/MedicalAppointmentForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/medical_appointments/documents/:id',
            name: 'medical_appointments.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "MEDICAL_APPOINTMENT"}
        },
        {
            path: '/medical_appointments/template_applications/:id',
            name: 'medical_appointments.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "MEDICAL_APPOINTMENT"}
        },
    ]
}